export default __webpack_public_path__ + "691791f0c578ca02eef4ecef215fae4d.svg";